export default __webpack_public_path__ + "static/media/team.7d6c73c8.png";